import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

import { getWorkPerformanceRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getWorkPerformanceRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {},
};

const getWorkPerformanceResultSlice = createSlice({
  name: "getWorkPerformanceResult",
  initialState,
  reducers: {
    getWorkPerformanceResultStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getWorkPerformanceResultSuccess: (
      state,
      action: PayloadAction<getWorkPerformanceRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getWorkPerformanceResultFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetWorkPerformanceResult: () => {
      return { ...initialState };
    },
  },
});

export const {
  getWorkPerformanceResultStart,
  getWorkPerformanceResultSuccess,
  getWorkPerformanceResultFailed,
  resetWorkPerformanceResult,
} = getWorkPerformanceResultSlice.actions;

export default getWorkPerformanceResultSlice.reducer;
